import React, { useState } from 'react';
import { toast } from 'sonner';
import { UsersThree } from '@phosphor-icons/react';
import { useI18n } from '../contexts/I18nContext';
import { useOrg } from '../contexts/OrgContext';
import { Switch } from './ui/switch';
import { useFamilyAlertPolicy, setFamilyAlertPolicy } from '../lib/familyAlerts';

// Admin/super-admin: let family members handle alerts of their own residents in this organisation.
export function FamilyAlertPolicySetting() {
  const { t } = useI18n();
  const { current } = useOrg() || {};
  const { policy, setPolicy, state, reload } = useFamilyAlertPolicy(current?.id);
  const [busy, setBusy] = useState(false);

  const save = async (value) => {
    setBusy(true);
    try { setPolicy(await setFamilyAlertPolicy(current.id, value)); toast.success(t('fap_saved')); }
    catch { toast.error(t('fap_save_failed')); reload(); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 py-6 border-t border-stone_line" data-testid="setting-family-alerts">
      <div className="flex items-start gap-4 min-w-0">
        <div className="w-10 h-10 rounded-xl bg-sage-100 text-sage-600 grid place-items-center shrink-0"><UsersThree size={20} weight="duotone" /></div>
        <div className="min-w-0">
          <div className="font-medium text-ink">{t('fap_title')}</div>
          <div className="text-sm text-ink-soft mt-1">{t('fap_desc', { org: current?.name || '' })}</div>
          {state === 'ready' && (
            <div className="text-xs text-ink-muted mt-2" data-testid="family-alerts-mode">
              {policy.automatic
                ? t(policy.caregiver_count === 0 ? 'fap_auto_on' : 'fap_auto_off')
                : <>{t('fap_manual')} <button type="button" className="text-sage-700 hover:underline ml-1" onClick={() => save(null)} disabled={busy} data-testid="family-alerts-reset">{t('fap_reset')}</button></>}
            </div>
          )}
        </div>
      </div>
      <div className="sm:shrink-0 pl-14 sm:pl-0">
        {state === 'ready' && (
          <Switch checked={!!policy.effective} disabled={busy} onCheckedChange={(v) => save(v)} data-testid="family-alerts-switch" />
        )}
        {state === 'loading' && <span className="text-xs text-ink-muted">…</span>}
        {state === 'pending' && <span className="text-xs text-ink-muted" data-testid="family-alerts-pending">{t('fap_pending')}</span>}
        {state === 'error' && <button type="button" onClick={reload} className="text-xs text-sage-700 hover:underline" data-testid="family-alerts-retry">{t('fap_retry')}</button>}
      </div>
    </div>
  );
}
